import { useCallback, useState, VFC } from 'react';
import { useDispatch } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel, Checkbox } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { TextInput } from '../components/Uikit/TextInput';
import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { signUpOperation } from '../reducks/users/operations';
import { useNavigate } from 'react-router-dom';

const SignUp: VFC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // 姓（カタカナ）
  const [lastNameKana, setLastNameKana] = useState<string>('');
  // 名（カタカナ）
  const [firstNameKana, setFirstNameKana] = useState<string>('');
  // メールアドレス
  const [email, setEmail] = useState<string>('');
  // パスワード
  const [password, setPassword] = useState<string>('');
  // パスワード（確認）
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  // 電話番号
  const [phone, setPhone] = useState<string>('');
  // 生年月日
  const [birthdayYear, setBirthdayYear] = useState<string>('');
  const [birthdayMonth, setBirthdayMonth] = useState<string>('');
  // 男女
  const [gender, setGender ] = useState<string>('');
  // 都道府県（居住地）
  const [address, setAddress] = useState<string>('');

  const currentYear = new Date().getFullYear();
  const years = Array.from({length: 120}, (_, i) => currentYear - 119 + i);
  const months = Array.from({length: 12}, (_, i) => 1 + i);

    /**
     * 入力された姓（カタカナ）をセット.
     */
    const inputLastNameKana = useCallback(
      (e) => {
        setLastNameKana(e.target.value);
      },
      [setLastNameKana]
    );
    /**
     * 入力された名（カタカナ）をセット.
     */
    const inputFirstNameKana = useCallback(
      (e) => {
        setFirstNameKana(e.target.value);
      },
      [setFirstNameKana]
    );
  /**
   * 入力されたメールアドレスをセット.
   */
  const inputEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );
  /**
   * 入力されたパスワードをセット.
   */
  const inputPassword = useCallback(
    (e) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );
  /**
   * 入力されたパスワード（確認）をセット.
   */
  const inputConfirmPassword = useCallback(
    (e) => {
      setConfirmPassword(e.target.value);
    },
    [setConfirmPassword]
  );
  /**
   * 入力された電話番号をセット.
   */
  const inputPhone = useCallback(
    (e) => {
      setPhone(e.target.value);
    },
    [setPhone]
  );
  /**
   * 入力されたBirthdayMonthをセット.
   */
  const inputBirthdayMonth = useCallback(
    (e) => {
      setBirthdayMonth(e.target.value);
    },
    [setBirthdayMonth]
  );
  /**
   * 入力されたBirthdayYearをセット.
   */
  const inputBirthdayYear = useCallback(
    (e) => {
      setBirthdayYear(e.target.value);
    },
    [setBirthdayYear]
  );
  /**
   * 入力されたgenderをセット.
   */
  const inputGender = useCallback(
    (e) => {
      setGender(e.target.value);
    },
    [setGender]
  );

  /**
   * 入力された都道府県（居住地）をセット.
   */
  const inputAddress = useCallback(
    (e) => {
      setAddress(e.target.value);
    },
    [setAddress]
  );

  const [termAgreed, setTermAgreed] = useState(false);
  const handleTermCheckboxChange = () => {
    setTermAgreed(!termAgreed);
  };

  // const [privacyAgreed, setPrivacyTermAgreed] = useState(false);
  // const handlePrivacyCheckboxChange = () => {
  //   setPrivacyTermAgreed(!privacyAgreed);
  // };

  const handleRegister = () => {
    if (!termAgreed) {
      alert('利用規約に同意してください。');
      return;
    }
    // if (!privacyAgreed) {
    //   alert('プライバシーポリシーに同意してください。');
    //   return;
    // }
    dispatch(signUpOperation(lastNameKana, firstNameKana, email, password, confirmPassword, phone, birthdayYear, birthdayMonth, gender, address, navigate));
  };

  return (
    <div className='mx-auto my-0 max-w-md p-4 h-auto w-[calc(100%_-_2rem)]'>
      <h2 className='text-pandacco text-2xl mt-0 mx-auto mb-4 text-center'>
        新規登録
      </h2>
      <div className='h-8 sm:h-12' />
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextInput
            fullWidth={true}
            label={'姓（カタカナ）'}
            multiline={false}
            required={true}
            rows={1}
            value={lastNameKana}
            type={'text'}
            onChange={inputLastNameKana}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            fullWidth={true}
            label={'名（カタカナ）'}
            multiline={false}
            required={true}
            rows={1}
            value={firstNameKana}
            type={'text'}
            onChange={inputFirstNameKana}
          />
        </Grid>
      </Grid>
      <TextInput
        fullWidth={true}
        label={'メールアドレス'}
        multiline={false}
        required={true}
        rows={1}
        value={email}
        type={'email'}
        onChange={inputEmail}
      />
      <TextInput
        fullWidth={true}
        label={'パスワード'}
        multiline={false}
        required={true}
        rows={1}
        value={password}
        type={'password'}
        onChange={inputPassword}
      />
      <TextInput
        fullWidth={true}
        label={'確認用パスワード'}
        multiline={false}
        required={true}
        rows={1}
        value={confirmPassword}
        type={'password'}
        onChange={inputConfirmPassword}
      />
      <TextInput
        fullWidth={true}
        label={'携帯電話番号（ハイフンなし11桁）'}
        multiline={false}
        required={true}
        rows={1}
        value={phone}
        type={'text'}
        onChange={inputPhone}
      />

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel>生年月日（年）</InputLabel>
            <Select
              value={birthdayYear}
              onChange={inputBirthdayYear}
              onOpen={() => {
                if (!birthdayYear) {
                  setBirthdayYear(currentYear.toString());
                }
              }}
            >
              {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel>生年月日（月）</InputLabel>
            <Select
              value={birthdayMonth}
              onChange={inputBirthdayMonth}
            >
              {months.map(month => <MenuItem key={month} value={month}>{month}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <FormControl fullWidth>
        <InputLabel>性別</InputLabel>
        <Select
          value={gender}
          onChange={inputGender}
        >
          <MenuItem value="male">男性</MenuItem>
          <MenuItem value="female">女性</MenuItem>
          <MenuItem value="neither">答えたくない</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel>都道府県</InputLabel>
        <Select
          value={address}
          onChange={inputAddress}
        >
          <MenuItem value="北海道">北海道</MenuItem>
          <MenuItem value="青森県">青森県</MenuItem>
          <MenuItem value="岩手県">岩手県</MenuItem>
          <MenuItem value="宮城県">宮城県</MenuItem>
          <MenuItem value="秋田県">秋田県</MenuItem>
          <MenuItem value="山形県">山形県</MenuItem>
          <MenuItem value="福島県">福島県</MenuItem>
          <MenuItem value="茨城県">茨城県</MenuItem>
          <MenuItem value="栃木県">栃木県</MenuItem>
          <MenuItem value="群馬県">群馬県</MenuItem>
          <MenuItem value="埼玉県">埼玉県</MenuItem>
          <MenuItem value="千葉県">千葉県</MenuItem>
          <MenuItem value="東京都">東京都</MenuItem>
          <MenuItem value="神奈川県">神奈川県</MenuItem>
          <MenuItem value="新潟県">新潟県</MenuItem>
          <MenuItem value="富山県">富山県</MenuItem>
          <MenuItem value="石川県">石川県</MenuItem>
          <MenuItem value="福井県">福井県</MenuItem>
          <MenuItem value="山梨県">山梨県</MenuItem>
          <MenuItem value="長野県">長野県</MenuItem>
          <MenuItem value="岐阜県">岐阜県</MenuItem>
          <MenuItem value="静岡県">静岡県</MenuItem>
          <MenuItem value="愛知県">愛知県</MenuItem>
          <MenuItem value="三重県">三重県</MenuItem>
          <MenuItem value="滋賀県">滋賀県</MenuItem>
          <MenuItem value="京都府">京都府</MenuItem>
          <MenuItem value="大阪府">大阪府</MenuItem>
          <MenuItem value="兵庫県">兵庫県</MenuItem>
          <MenuItem value="奈良県">奈良県</MenuItem>
          <MenuItem value="和歌山県">和歌山県</MenuItem>
          <MenuItem value="鳥取県">鳥取県</MenuItem>
          <MenuItem value="島根県">島根県</MenuItem>
          <MenuItem value="岡山県">岡山県</MenuItem>
          <MenuItem value="広島県">広島県</MenuItem>
          <MenuItem value="山口県">山口県</MenuItem>
          <MenuItem value="徳島県">徳島県</MenuItem>
          <MenuItem value="香川県">香川県</MenuItem>
          <MenuItem value="愛媛県">愛媛県</MenuItem>
          <MenuItem value="高知県">高知県</MenuItem>
          <MenuItem value="福岡県">福岡県</MenuItem>
          <MenuItem value="佐賀県">佐賀県</MenuItem>
          <MenuItem value="長崎県">長崎県</MenuItem>
          <MenuItem value="熊本県">熊本県</MenuItem>
          <MenuItem value="大分県">大分県</MenuItem>
          <MenuItem value="宮崎県">宮崎県</MenuItem>
          <MenuItem value="鹿児島県">鹿児島県</MenuItem>
          <MenuItem value="沖縄県">沖縄県</MenuItem>
        </Select>
      </FormControl>
      <p className="text-lg text-gray-600 text-right">
        <span className="text-2xl text-customRed">*</span> は必須項目です
      </p>
      <div>
        <Checkbox
          id="agreeTerms"
          checked={termAgreed}
          onChange={handleTermCheckboxChange}
          color="primary"
        />
        <label htmlFor="agreeTerms">
          <span>当店の</span>「
        </label>
        <span
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={(e) => {
            e.stopPropagation(); // クリックが label に伝播しないようにする
            window.open('/terms-of-service', '_blank', 'noopener');
          }}
        >
          利用規約
        </span>
        」と「
        <span
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={(e) => {
            e.stopPropagation();
            window.open('/privacy-policy', '_blank', 'noopener');
          }}
        >
          プライバシーポリシー
        </span>
        」に同意します
      </div>
      {/* <div>
        <Checkbox
          id="agreePrivacy"
          checked={privacyAgreed}
          onChange={handlePrivacyCheckboxChange}
          color="primary"
        />
        <label htmlFor="agreePrivacy">
          {' '}当店の「
          <span
            style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => navigate('/privacy-policy')}
          >
            プライバシーポリシー
          </span>
          」に同意します
        </label>
      </div> */}
      <div className='h-8 sm:h-12' />
      <div className='mx-auto my-0 text-center'>
        <PrimaryButton
          label='登録する'
          onClick={handleRegister}
        />
        <p
          onClick={() => navigate('/signin')}
          className='cursor-pointer underline hover:opacity-70'
        >
          登録済みの方はこちら
        </p>
      </div>
    </div>
  );
};

export default SignUp;
